import React from 'react'
import styled from 'styled-components';
import { useState, useEffect, useRef } from 'react';
import { useGetassetReqQuery } from '../../../../features/assetrequest/assetReqApiSlice'
import { useGetAssetsFinalQuery } from '../../../../features/addassets/addassetfinalApiSlice'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ReactTooltip from "react-tooltip";
import moment from 'moment'
import { HeadingWrap, Span,PreDataWrap,RequestClosureWarapperAccepted, BackButtonSpan } from '../../../../Styles/CommonStyles'


const Container = styled.div``
const Wrapper = styled.div`
display: flex;
flex-direction: column;
`
const ReqWrapper = styled.div``
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
const PreDataCont = styled.div`
`
const NoteCountCont = styled.div`
font-size: 22px;
font-weight: 600;
`
const OldAssetWrapper = styled.div`
display: flex;
`
const TextWrapper = styled.div`
font-size: 20px;
`
const TimeAndNameCont = styled.div`
display: flex;
font-size: 20px;
justify-content: space-between;
`
const TimeWrapper = styled.div`
font-size: 20px;
`
const UserNameContainer = styled.div`
padding-right: 30px;
font-size: 20px;
`

// table style
const tableStyle = {
    width: '53%',
    borderCollapse: 'collapse',
    marginTop: '20px',
};

const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
    fontSize: '20px'
};

const thStyle = {
    backgroundColor: '#aae2e4',
    fontSize: '23px'
};

const evenRowStyle = {
    backgroundColor: '#f9f9f9',
};

const DirectReqForm = ({ reqid, setChangepage }) => {

    //Single Request call
    const { getSingleRequest } = useGetassetReqQuery('allassetReqlist', {
        selectFromResult: ({ data }) => ({
            getSingleRequest: data?.entities
        }),
    })

    //get single assets
    const { getSingleasset } = useGetAssetsFinalQuery('allassetlist', {
        selectFromResult: ({ data }) => ({
            getSingleasset: data?.entities
        }),
    })

    return (
        <Container>
            <BackArrowContainer onClick={() => setChangepage([true, false, false, false, false])}><ArrowLeftIcon /><BackButtonSpan >Back to Category Table</BackButtonSpan></BackArrowContainer>
            <Wrapper>
                <ReqWrapper>
                    <HeadingWrap>
                        <Span>Request category: Direct</Span>
                    </HeadingWrap>
                    <HeadingWrap>
                        <Span>Request Type: {getSingleRequest[reqid]?.req_cat}</Span>
                    </HeadingWrap>
                    <PreDataCont>
                        {getSingleRequest[reqid]?.req_data.map((elm, ind) =>
                            <PreDataWrap key={ind}>
                                <HeadingWrap>
                                    <NoteCountCont>Note-{ind + 1}</NoteCountCont>
                                </HeadingWrap>
                                <span style={{ fontSize: '20px' }}>Requested Asset Details (selected in the checkbox):</span>
                                {elm.assets_details && getSingleasset && <OldAssetWrapper>
                                    <table style={tableStyle}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Assets</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>OEM Tags</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>OEM/Brand</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Purchase Date</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Warranty Date</th>
                                                <th style={{ ...thTdStyle, ...thStyle }}>Specifications</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {elm.assets_details?.map(element => { return getSingleasset && getSingleasset[element] })?.map((row, index) => (
                                                <tr key={index} style={(index + 1) % 2 === 0 ? evenRowStyle : null}>
                                                    {console.log(row)}
                                                    <td style={thTdStyle}>{row.name}</td>
                                                    <td style={thTdStyle}>{row.oem_tag}</td>
                                                    <td style={thTdStyle}>{row.oem}</td>
                                                    <td style={thTdStyle}>{moment(row.purchase_date).format('DD/MM/YYYY')}</td>
                                                    <td style={thTdStyle}>{moment(row.warrantyexp_date).format('DD/MM/YYYY')}</td>
                                                    <td style={thTdStyle}><div className="App">
                                                        <div data-tip data-for={row._id}>
                                                            Hover here to view Specifications
                                                        </div>
                                                        <ReactTooltip id={row._id} place="top" effect="solid">
                                                            <div>
                                                                {Object.entries(row.specification).map(([key, val]) => <h4 key={key}>{key}: {val}</h4>)}
                                                            </div>
                                                        </ReactTooltip>
                                                    </div></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </OldAssetWrapper>}
                                <TextWrapper>
                                    Remark: <div dangerouslySetInnerHTML={{ __html: elm.Text }} />
                                </TextWrapper>
                                <TimeAndNameCont>
                                    <TimeWrapper>
                                        {getSingleRequest[reqid]?.req_data[getSingleRequest[reqid]?.req_data.length - 1].time_stamp}
                                    </TimeWrapper>
                                    <UserNameContainer>
                                        {`${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.firstName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.middleName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.lastName}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.office}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.designation} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.designationSuffix}`}
                                    </UserNameContainer>
                                </TimeAndNameCont>
                            </PreDataWrap>)}
                    </PreDataCont>
                    <RequestClosureWarapperAccepted>This is direct Request craeted on behalf of reference ducument/letter. </RequestClosureWarapperAccepted>
                </ReqWrapper>
            </Wrapper>
        </Container>
    )
}

export default DirectReqForm